import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'

const basePath = '/v-admin/client-admin/ads-tier-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_SET_ADS_ORDER'],
    menu: {
      labelI18nKey: 'admin.customer.adsTierManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.customer.adsTierManagement.title'
      }
    }
  ]
}
